import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-course-header',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './course-header.component.html',
  styleUrl: './course-header.component.scss',
})
export class CourseHeaderComponent {
  title = input<string>('');
  rating = input<number>(0);
  completionPercent = input<number | undefined>(undefined);
  tasksProgress = input<{ completed: number; total: number } | undefined>(
    undefined,
  );
}
